import { UserRejectedRequestError } from 'viem';
import { hasCode } from './utils';

// Function to determine if the error is because the user rejected the web transaction
export const isUserRejectedError = (error: unknown) => {
  if (hasCode(error) && error?.code === 'ACTION_REJECTED' || error instanceof UserRejectedRequestError || error instanceof Error && Object.hasOwn(error, 'message') && error.message.includes('User rejected the request')) {
    return true;
  }
  return false;
};